<template>
    <div class="user_grzx" v-loading="loading">
        <div class="user_box1">
            <div class="user_info">
                <div class="user_imgs">
                    <img src="@/assets/img/user_info/user_grzx/user_img.png" alt="">

                </div>
                <div class="user_name_phone">
                    <div class="name">{{ user_info.name }}</div>
                    <div class="phone">{{ user_info.mobile }}</div>
                </div>
                <div class="urer_grade">
                    <img src="@/assets/img/user_info/user_grzx/vip.png" alt="">
                    律师
                </div>
            </div>
            <div class="user_orders">
                <div class="icons" v-for="(item,index) in icon_list" :key="index">
                    <div class="nums">
                        {{ item.num }}
                    </div>
                    <div class="texts">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
        <div class="user_box2">
            <div class="box_header">
                <div class="lefts">
                    <div class="borders"></div>
                    <div class="titles">点评服务</div>
                </div>
                <div class="rights">
                    <div class="btns" @click="$router.push('/user_dpfw')">
                        全部订单
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
            </div>
            <div class="order_0" v-if="order_list.length==0">
                <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
                <div class="texts">暂无待处理订单</div>
            </div>
            <div class="order_list" v-if="order_list.length!=0">
                <div class="order_item" v-for="(item,index) in order_list" :key="index">
                    <div class="item_titles">
                        <div class="order_lefts">
                            <div class="order_time">{{ item.case.created_at }}  </div>
                            <div class="order_no">订单号：{{ item.case.order_sn }}</div>
                        </div>
                        <div class="order_rights">
                            待点评
                        </div>
                    </div>
                    <div class="order_info">
                        <div class="shop_list">
                            <div class="shop_item">
                                <div class="shop_left">
                                    <div class="shop_img">
                                        <img src="@/assets/img/index/comments_case/grade_c.png" alt="" v-if="item.grade==1">
                                        <img src="@/assets/img/index/comments_case/grade_z.png" alt="" v-if="item.grade==2">
                                        <img src="@/assets/img/index/comments_case/grade_g.png" alt="" v-if="item.grade==3">
                                        <img src="@/assets/img/index/comments_case/grade_t.png" alt="" v-if="item.grade==4">
                                    </div>
                                    <div class="shop_title">{{ item.case.title }}</div>
                                </div>
                                <div class="shop_right">
                                    <div class="shop_price1">{{item.case.pay_money}}</div>
                                  
                                </div>
                            </div>
                        </div>
                        <div class="order_btns">
                            <div class="btns_lefts">
                                <div class="text1">
                                    <img src="@/assets/img/index/comments_case/user_img.png" alt="" v-if="!item.user.image">
                                     <img :src="item.user.image" alt="" v-if="item.user.image">
                                    {{ item.user.nickname||'用户昵称' }}
                                </div>
                                <div class="text2">
                                    合计金额
                                    <span> {{item.case.pay_money}}</span>
                                    元 
                                </div>
                            </div>
                            <div class="btns_right">
                                <div class="btns1" @click="handle_detial(item)">订单详情</div>
                                <div class="btns2" @click="handle_add(item)" v-if="item.status==10">立即点评</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 


export default {
    props:{
        user_info:{
            type: Object,
             default: {}
		},
    },
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading:false,
            icon_list:[
                {
                    num:0,
                    title:'点评服务',
                    path:'/user_dpfw',
                },
                {
                    num:0,                 
                    title:'委托服务',
                    path:'/user_wtfw',

                },
                {
                    num:0,
                    title:'我的服务费',
                    path:'',

                },
            ],
            order_list:[],
           
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_list()
        this.get_wt_list()
    },
    methods: {
        get_list(){
            this.loading = true
            this.$api("lawyerCaseCommentList", {
                status:10,
                page:1,
                limit:2,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的点评列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                    this.icon_list[0].num=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_wt_list(){
            this.loading=true
            this.$api("lawyerOrders", {
                status: 30
			}, "get").then((res) => {
                this.loading = false
                console.log('我的委托列表',res)
                if (res.code == 1) {
                    this.icon_list[1].num=res.data.total
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_detial(item){
            this.$router.push({
                path:'/user_dpfw/user_dpfw_detial',
                query:{
                    id:item.case.id,
                }
            })
        },
        handle_add(item){
            this.$router.push({
                path:'/user_dpfw/user_dpfw_add',
                query:{
                    id:item.case.id,
                    grade:item.grade,
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.user_grzx{
    .user_box1{
        display: flex;
        align-items: center;
        .user_info{
            width: 256px;
            height: 210px;
            flex-shrink: 0;
            background: url('../../assets/img/user_info/user_grzx/bg1.png');
            background-size: 100%;
            border-radius: 12px 12px 12px 12px;
            overflow: hidden;
            position: relative;
            .user_imgs{
                padding-top: 26px;
                display: flex;
                justify-content: center;
                img{
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                }
            }
            .user_name_phone{
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 12px;
                .name{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;
                }
                .phone{
                    margin-left: 8px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;

                }
            }
            .urer_grade{
                position: absolute;
                bottom: 1px;
                left: 1px;
                width: 254px;
                height: 48px;
                background: #FFFFFF;
                border-radius: 0px 0px 11px 11px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                img{
                    width: 24px;
                    margin-right: 4px;
                }
            }
            
        }
        .user_orders{
            width: 940px;
            height: 185px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .icons{
                width: 33%;

                .nums{
                    text-align: center;
                    padding-bottom: 25px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 24px;
                    color: #377CFD;

                }
                .texts{
                    cursor: pointer;
                    text-align: center;
                    padding-top: 12px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;

                }
            }
        }

    }
    .user_box2{
        margin-top: 25px;
        width: 1196px;
        min-height: 337px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .box_header{
           height: 56px; 
           display: flex;
           align-items: center;
           justify-content: space-between;
           border-bottom:1px solid #DEDEDE;
           .lefts{
                height: 56px; 
                display: flex;
                align-items: center;
                .borders{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .titles{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #333333;
                    padding-left: 28px;
                }
           }    
           .rights{
                padding-right: 32px;
                .btns{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    cursor: pointer;
                    img{
                        width: 14px;
                        // margin-left: 8px;
                    }
                }
           }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding: 32px;
            .order_item{
                width: 1132px;
                // min-height: 200px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                margin-bottom: 20px;
                .item_titles{
                    width: 1132px;
                    height: 44px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding:0 24px ;
                    .order_lefts{
                        display: flex;
                        align-items: center;
                        .order_time{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                            margin-right: 20px;
                        }
                        .order_no{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                        }
                    }
                    .order_rights{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;

                    }
                }
                .order_info{
                    padding:0 24px;
                    padding-top: 24px;
                    .shop_list{
                        
                        border-bottom: 1px solid #E5E5E5;
                        .shop_item{
                            margin-bottom: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .shop_left{
                                display: flex;
                                align-items: center;
                                .shop_img{
                                    width: 70px;
                                    // height: 104px;
                                    img{
                                        width: 70px;
                                        // height: 104px;
                                    }
                                }
                                .shop_title{
                                    padding-left: 24px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 16px;
                                    color: #333333;

                                }
                            }
                            .shop_right{
                                display: flex;
                                align-items: center;
                                .shop_price1{
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;

                                }
                                
                            }
                        }
                    }
                    .order_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 64px;
                        .btns_lefts{
                            display: flex;
                            align-items: center;
                            .text1{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                img{
                                    width:40px ;
                                    height: 40px;
                                    margin-right: 16px;
                                }
                                
                            }
                            .text2{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                margin-left: 20px;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;

                                }
                            }
                        }
                        .btns_right{
                            display: flex;
                            align-items: center;
                            .btns1{
                                width: 104px;
                                height: 32px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                line-height: 32px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                            }   
                            .btns2{
                                width: 104px;
                                height: 32px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 32px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                                margin-left: 10px;
                            }

                        }
                    }
                    

                }
            }
        }
    }
  
}

</style>